import React from "react";
import { BrowserRouter } from "react-router-dom";
import AllRoutes from "./routes/allRoutes";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from "./AuthProvider";


function App() {
  return (
    <>
<ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="light"
    />
    <BrowserRouter>
    <AuthProvider>
      <AllRoutes />
      </AuthProvider>
    </BrowserRouter>
 </>
  );
}

export default App;
